import { ApisauceInstance } from 'apisauce';

const getDriverRewardsOutput = ({
  api,
  driver,
  bonusProgramId,
  intervalId,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  intervalId: string;
}) => {
  return api.get<BonusTypes.Rewards.AnyDriverRewardsOutput>(
    `/v1/driver_bonus/rewards?driver=${driver}&bonus_period_id=${intervalId}&bonus_config_id=${bonusProgramId}`,
  );
};

export default getDriverRewardsOutput;
